let aboutData = {
    "name": "Natalie Nguyen",
    "description": "I'm Natalie Nguyen, a Software Engineer with a Master of Science in Computer Science and over a decade of experience designing, developing, and scaling enterprise web applications and database architectures. Specialized in C#, .NET Core/ASP.NET, REST APIs, SQL Server, and modern frontend architectures including Angular and TypeScript. Expert in authoring complex stored procedures, executing deep SQL Server query performance optimization, integrating enterprise tools like SharePoint Lists, and automating Azure Pipelines CI/CD workflows.",
    "phone": "",
    "email": "natalie.nutm@gmail.com",
    "resume": "Natalie_Nguyen_SoftwareEngineer.pdf"
};

export default aboutData;